import { defineComponent as _defineComponent } from 'vue'
import VsButton from '@/components/vision/VsButton.vue'

type ItemType = { id: string | number | null; label: string }


export default /*#__PURE__*/_defineComponent({
  __name: 'ChipFilter',
  props: {
    value: null,
    items: null
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update', value: ItemType): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: ItemType | null
  items?: ItemType[]
}





const valueCompare = (obj1?: ItemType | null, obj2?: ItemType | null) => {
  return obj1?.id === obj2?.id
}

const change = (obj: ItemType) => {
  emit('update', obj)
}

return { __sfc: true,props, emit, valueCompare, change, VsButton }
}

})